import React from "react";

import { seloTerapeutico } from "../../../utils/copy";

/* Pôster amarelo full-bleed: o selo "não é terapia…" deixou o painel escuro
   e virou faixa entre "o que é" e "quem conduz" (jul/2026). Sem CTA — o
   botão saiu pra não competir com o texto. */
export function SeloTerapeutico() {
  return (
    <section id="selo-terapeutico" data-bg="#f4e437" className="poster-section therapeutic-seal-section">
      <div className="therapeutic-seal-inner">
        <h2 data-motion="title" className="type-display therapeutic-seal-title" aria-label={seloTerapeutico.titulo}>
          <span>Não é terapia,</span>
          {/* "mas é terapêutico" não quebra: Anton + TERAPÊUTICO estouravam a
              linha no mobile e cortavam a frase no meio. Espaço entre spans
              mantém a frase legível pra leitores/testes. */}
          <span className="therapeutic-seal-line"> mas é terapêutico</span>
        </h2>
        <p data-motion="lead" className="type-voice therapeutic-seal-body">
          {seloTerapeutico.corpo}
        </p>
      </div>
    </section>
  );
}
